<template>
  <div class="content-tab lldpconfig">
    <div class="content-body">
      <loading :mask=true :size="'big'" :isWhite=true v-if="isShowLoading"/>
      <div class="describe">
        {{$t('lldp.describe')}}
      </div>
      <div class="formRow">
        <span class="title">{{$t('lldp.enablelldp')}}</span>
        <toggle :on="islldpEnable" @click.native="onSwitchBtn()"></toggle>
      </div>
      <!-- <div class="formRow">
        <table class="config-table">
          <tr>
            <td class="title">
              {{$t('lldp.globalConfig')}}
            </td>
            <td>
              <div class="title">{{$t('lldp.txInterval')}}</div>
              <div class="value">
                <input name="txInterval" class="form-control value" type="text" v-model="config.msgTxInterval" v-validate="'required|numeric|max_value:32768|min_value:5'" @keyup="onBlur" :class="{'error': errors.has('txInterval')}">
              </div>
              <div v-show="errors.has('txInterval')" ref="Tx Interval" class="errorMessage">{{setErrorMessage(errors.first('txInterval'), 'Tx Interval')}}</div>
            </td>
            <td>
              <div class="title">{{$t('lldp.txHold')}}</div>
              <div class="value">
                <input name="txHold" class="form-control value" type="text" v-model="config.msgTxHold" v-validate="'required|numeric|max_value:10|min_value:2'" @keyup="onBlur" :class="{'error': errors.has('txHold')}">
              </div>
              <div v-show="errors.has('txHold')" ref="Tx Hold" class="errorMessage">{{setErrorMessage(errors.first('txHold'), 'Tx Hold')}}</div>
            </td>
            <td>
              <div class="title">{{$t('lldp.txDelay')}}</div>
              <div class="value">
                <input name="txDelay" class="form-control value" type="text" v-model="config.txDelay" v-validate="'required|numeric|max_value:8192|min_value:1'" @keyup="onBlur" :class="{'error': errors.has('txDelay')}">
              </div>
              <div v-show="errors.has('txDelay')" ref="Tx Delay" class="errorMessage">{{setErrorMessage(errors.first('txDelay'), 'Tx Delay')}}</div>
            </td>
            <td>
              <div class="title">{{$t('lldp.txReinit')}}</div>
              <div class="value">
                <input name="reInitDelay" class="form-control value" type="text" v-model="config.ReInitDelay" v-validate="'required|numeric|max_value:10|min_value:1'" @keyup="onBlur" :class="{'error': errors.has('reInitDelay')}">
              </div>
              <div v-show="errors.has('reInitDelay')" ref="Tx Reinit" class="errorMessage">{{setErrorMessage(errors.first('reInitDelay'), 'Tx Reinit')}}</div>
            </td>
          </tr>
        </table>
      </div>
      <div class="group-table" ref="groupTable" >
        <fixed-table :data="ports" :use-page="false" :header-height="30">
            <div class="right-header" slot="right-header">
              <column style="width: 20%;">{{$t('acl.port')}}</column>
              <column style="width: 80%;">{{$t('lldp.mode')}}</column>
            </div>
            <template slot="rows" slot-scope="props">
                <div class="link-row">
                    <row class="right" :props="props">
                      <div class="data" style="width: 20%;">{{getPortName(props.data.key)}}</div>
                      <div class="data" style="width: 80%;">
                        <q-select class="q-select" :props="props.index" :value="props.data.val.AdminState" :options-array="optionsList" :rule="props.data.key" @change="onMenuChange"></q-select>
                      </div>
                    </row>
                </div>
            </template>
        </fixed-table>
      </div> -->
      <div class="content-body-footer">
        <button class="q-button blue-btn-full right" :title="$t('save')" @click="onSaveClick()" :disabled="!saveBtn">{{$t('save')}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import toggle from './module/Toggle'
import fixedTable from './table/FixedTable'
import row from './table/row/Row'
import column from './table/column/Column'
import qSelect from './module/Select.vue'

export default {
  name: 'LldpConfig',
  components: {
    toggle,
    fixedTable,
    row,
    column,
    qSelect
  },
  data () {
    return {
      isShowLoading: false,
      islldpEnable: false,
      isDisabled: false,
      isAllSame: true,
      ports: [],
      originalData: [],
      originalEnable: null,
      config: [],
      originalConfig: [],
      saveBtn: false,
      optionsList: [
        {label: '--', value: 0, rule: 'all'},
        {value: 4, label: 'poe.config.disableMode'},
        {value: 3, label: 'mirroring.transReceive'},
        {value: 1, label: 'mirroring.transOnly'},
        {value: 2, label: 'mirroring.receiveOnly'}
      ],
      isResizeTable: false
    }
  },
  created: async function () {
    this.getData()
  },
  beforeRouteLeave (to, from, next) {
    if (this.isDataChanged) {
      next(false)
    } else {
      next()
    }
  },
  watch: {
    saveBtn: function (value) {
      if (!value) {
        this.$store.commit('updateDataChanged', false)
      } else {
        this.$store.commit('updateDataChanged', true)
      }
    }
  },
  methods: {
    ...mapActions(['getLLDPinterfaceConfig', 'setLLDPinterfaceConfig', 'getLLDPglobalConfig', 'setLLDPglobalConfig']),
    onMenuChange: function (value, index) {
      this.ports[index].val.AdminState = value
      this.onChange(index)
    },
    getData: function () {
      let self = this
      this.isShowLoading = true
      this.saveBtn = false
      // this.getLLDPglobalConfig()
      //   .then((res) => {
      //     if (!res.error) {
      //       this.config = res.result
      //       this.originalConfig = JSON.parse(JSON.stringify(res.result))
      //     }
      //   })
      this.getLLDPinterfaceConfig()
        .then((res) => {
          let tempEnable = false
          let preMode = ''
          if (!res.error) {
            self.originalData = JSON.parse(JSON.stringify(res.result))
            res.result.forEach(element => {
              if (element.val.AdminState !== 4) {
                tempEnable = true
              }
              if (preMode === '') {
                preMode = element.val.AdminState
              } else if (preMode !== element.val.AdminState) {
                self.isAllSame = false
              }
            })
            if (self.isAllSame) {
              self.ports = [{
                key: 'all',
                val: {
                  AdminState: res.result[0].val.AdminState
                }
              }]
            } else {
              self.ports = [{
                key: 'all',
                val: {
                  AdminState: 0 // none
                }
              }]
            }
            self.ports.push.apply(this.ports, res.result)
            self.islldpEnable = tempEnable
            self.originalEnable = tempEnable
            self.isShowLoading = false
          }
        })
    },
    getPortName: function (item) {
      if (item && item !== 'all') {
        return item
      } else if (item === 'all') {
        return this.$t('all')
      }
    },
    onBlur: function (event) {
      this.checkValidation()
    },
    checkSaveBtnDisabled: function () {
      this.saveBtn = (this.islldpEnable !== this.originalEnable)
    },
    checkValidation: function (fieldName) {
      let me = this
      this.$validator.validateAll().then((result) => {
        me.saveBtn = result
        this.isResizeTable = !result
        if (!this.isResizeTable) {
          this.$refs.groupTable.style.paddingTop = '20px'
        }
      }).catch(() => {
        me.saveBtn = false
      })
    },
    onChange: function (index) {
      if (index >= 0) {
        let item = this.ports[index]
        let mode = item.val.AdminState
        if (item.key === 'all' && mode !== 0) {
          this.ports.forEach((element, index) => {
            if (index > 0) {
              this.ports[index].val.AdminState = mode
            }
          })
        }
        this.$forceUpdate()
        this.saveBtn = true
      }
    },
    onSwitchBtn: function () {
      this.saveBtn = true
      this.islldpEnable = !this.islldpEnable
      if (this.islldpEnable) {
        this.isDisabled = false
        this.ports[0].val.AdminState = 3
        this.onChange(0)
      } else {
        this.isDisabled = true
      }
      this.checkSaveBtnDisabled()
    },
    onSaveClick: function () {
      let self = this
      let requests = 0
      let tempList = JSON.parse(JSON.stringify(this.ports))
      let data = []
      this.isShowLoading = true
      tempList.splice(0, 1)
      tempList.forEach(element => {
        element.val.AdminState = (!this.islldpEnable && this.islldpEnable !== this.originalEnable) ? 4 : 3 // disable
        data[requests] = { 'idx': element.key, 'data': element.val }
        requests++
        if (requests === tempList.length) {
          self.setLLDPinterfaceConfig(data)
            .then((res) => {
              self.getData()
            })
        }
      })
      // else if (!this.$compareObj(this.originalData, tempList)) {
      //   tempList.forEach(element => {
      //     element.val.AdminState = element.val.AdminState
      //     requests.push(self.setLLDPinterfaceConfig(element))
      //   })
      //   this.axios.all(requests)
      //     .then((res) => {
      //       self.getData()
      //     })
      // }
      // for (const key in this.config) {
      //   if (this.config.hasOwnProperty(key)) {
      //     const element = this.config[key]
      //     this.config[key] = parseInt(element)
      //   }
      // }
      // if (!this.$compareObj(this.originalConfig, this.config)) {
      //   this.setLLDPglobalConfig(this.config)
      //     .then((res) => {
      //       this.getData()
      //     })
      // }
    },
    setErrorMessage: function (data, fieldName) {
      let message = fieldName
      if (data) {
        if (data.indexOf('required') > -1) {
          message = this.$t('errorMessage.isReguired')
        } else {
          switch (fieldName) {
            case 'Tx Interval':
              message = this.$t('errorMessage.txIntervalError')
              break
            case 'Tx Hold':
              message = this.$t('errorMessage.txHoldError')
              break
            case 'Tx Delay':
              message = this.$t('errorMessage.txDelayError')
              break
            case 'Tx Reinit':
              message = this.$t('errorMessage.txReinitError')
              break
          }
        }
        if (this.$refs[fieldName].offsetHeight > 20 && this.isResizeTable) {
          this.$refs.groupTable.style.paddingTop = '40px'
        }
      }
      return message
    }
  },
  computed: {
    ...mapState({
      isDataChanged: state => state.app.isDataChanged
    })
  }
}
</script>

<style lang="scss" scoped>

.lldpconfig {
  position: relative;
  padding: 10px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  .describe {
    margin-bottom: 25px;
  }
  .config-table {
    width: 100%;
    table-layout: fixed;
    >tr {
      height: 52px;
      >td {
        position: relative;
        >.title, >.value {
          margin-right: 10px;
          border-right: 1px solid #F1F1F1;
        }
        >.value >input {
          width: 70px;
        }
        &:last-child {
          >div {
            border-right: none;
          }
        }
      }
    }
    .errorMessage {
      position: absolute;
      width: inherit;
    }
  }
  .group-table {
    padding-top: 20px;
    height: calc(100% - 225px);
    .data-row {
      overflow: visible !important;
      height: 38px;
      .data {
        overflow: visible !important;
        .form-control {
          width: 200px;
          display: inline-block;
        }
      }
    }
  }
  .content-body-footer {
    position: absolute;
    top: calc(100% - 50px) !important;
  }
  .q-select .display-label {
    font-size: 13px;
    color: #000;
  }
  .q-select {
    width: 200px;
    height: 30px;
    border: 1px solid #979797 !important;
    border-radius: 4px;
    vertical-align: middle;
    /deep/ .dropdown-menu {
      left: -1px;
      width: 200px;
      height: auto;
      overflow: auto;
    }
    /deep/ .display-label {
      font-size: 13px !important;
      color: #2F2F2F !important;
      line-height: 30px !important;
    }
    &::after {
      background-color: #000;
      top: -25px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LldpConfig.vue